var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuniperBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F1F5E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#133F26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78851 9.14785c-.07844-.01031-.15819-.00422-.23419.01791-.07778.02264-.14985.06157-.21144.11419m.44563-.1321c2.15749.35981 4.13689 1.41275 5.64009 2.99655v9.9333c-1.6242-1.3932-3.6234-2.2966-5.76321-2.5868-.00464-.0006-.00929-.0012-.01395-.0017-.14041-.0156-.27009-.0826-.36401-.1881-.09392-.1055-.14542-.2421-.14456-.3834l.00001-9.20343c-.00001-.08254.01787-.16413.05239-.2391.03451-.07492.08494-.14159.14761-.19522m-.10802-1.21149c.23349-.06798.47878-.0855.71957-.0514.00449.00063.00897.00132.01344.00206 2.48603.41261 4.76023 1.65155 6.45503 3.51658.0956.1052.1486.2422.1486.3843v11.5086c0 .2361-.1453.4479-.3655.533-.2203.0851-.4702.0259-.629-.1488-1.5822-1.742-3.7274-2.8709-6.05904-3.1886-.41824-.0482-.80422-.2487-1.08424-.5633-.28134-.3161-.4358-.7251-.4337-1.1482V9.71431c0-.00001 0 .00001 0 0-.00001-.2476.05361-.4923.15719-.7172.10357-.22491.25464-.42471.44281-.58566.18486-.15802.40134-.27501.63484-.34299Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0456 8.01706c.2408-.0341.4861-.01658.7196.0514.2335.06798.4498.18486.6347.34288.1882.16095.3394.36086.4429.58577.1036.2249.1572.46956.1572.71716 0 .00001 0-.00001 0 0v9.19833c.0021.4232-.1523.8322-.4337 1.1483-.28.3146-.666.5151-1.0842.5633-2.3316.3177-4.4769 1.4466-6.0591 3.1886-.1588.1747-.4087.2339-.6289.1488-.2203-.0851-.3655-.2969-.3655-.533V11.92c0-.1421.0529-.2791.1485-.3843 1.6948-1.86503 3.969-3.10397 6.4551-3.51658.0044-.00074.0089-.00143.0134-.00206Zm.1659 1.13079c-2.1575.35981-4.1369 1.41275-5.6401 2.99655v9.9333c1.6242-1.3932 3.6235-2.2966 5.7632-2.5868.0047-.0006.0093-.0012.014-.0017.1404-.0156.2701-.0826.364-.1881.0939-.1055.1454-.2421.1446-.3834l-.0001-.0034.0001-9.20003c0-.08254-.0179-.16413-.0524-.2391-.0345-.07492-.0849-.14148-.1475-.19512m-.4458-.1322c.0785-.01031.1582-.00422.2342.01791.0778.02264.15.06167.2116.11429"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h16v16H8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniperBook);
export default __webpack_public_path__ + "static/media/juniper-book.d4a0b98bcc31ecc1923b562c1f36758a.svg";
export { ForwardRef as ReactComponent };